<div class = "filter" [ngClass]="{'selectableFilters': searchString}">
    <span (click)="filterElements('contains')">{{'common.filter.contains' | translate}}({{filter.contains}})</span>
    <span (click)="filterElements('doesnotcontain')">{{'common.filter.notContains' | translate}}({{filter.notContains}})</span>
    <span (click)="filterElements('eq')">{{'common.filter.isSame' | translate}}({{filter.isSame}})</span>
    <span (click)="filterElements('neq')">{{'common.filter.notSame' | translate}}({{filter.notSame}})</span>
    <span (click)="filterElements('startswith')">{{'common.filter.startsWith' | translate}}({{filter.startsWith}})</span>
    <span (click)="filterElements('endswith')">{{'common.filter.endsWith' | translate}}({{filter.endsWith}})</span>
</div>
